export default "__VITE_ASSET__p49YhLd0__"